import {
  Box,
  Card,
  CardActionArea,
  CardContent,
  colors,
  Tooltip,
  Typography,
} from "@mui/material";
import { CorporateService } from "../models/Service";
import { useNavigate } from "react-router-dom";

const ServiceCard = ({ service }: { service: CorporateService }) => {
  const navigate = useNavigate();
  const onSelectService = () => {
    navigate(`${service.id}`);
  };

  const { url } = service.logo;
  return (
    <>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          mx: 2,
          marginBottom: 4,
        }}
        data-testid="service-card"
        onClick={onSelectService}
      >
        <Tooltip title={service?.service_name}>
          <Card
            key={service?.service_name}
            sx={{
              height: 85,
              width: 260,
              backgroundColor: "#f7fafe",
              boxShadow: "0px 4px 16px 0px #0000001A",
            }}
            elevation={4}
          >
            <CardActionArea
              sx={{
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "center",
                px: 1,
                height: "100%",
              }}
            >
              <img
                style={{ width: 62 }}
                src={`${url}`}
                alt={service.service_name}
              />

              <CardContent
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  width: 170,
                  px: 1,
                }}
              >
                <Typography
                  noWrap
                  variant={"body2"}
                  sx={{
                    textTransform: "uppercase",
                    fontWeight: "bolder",
                    fontSize: 12,
                    width: "100%",
                  }}
                >
                  {service.service_name}
                </Typography>

                <Typography
                  noWrap
                  variant={"body2"}
                  sx={{ color: colors.grey[600], width: "100%" }}
                >
                  {service?.service_description}
                </Typography>
              </CardContent>
            </CardActionArea>
          </Card>
        </Tooltip>
      </Box>
    </>
  );
};

export default ServiceCard;
